// assets
import { IconDashboard, IconZoomScan, IconTruckDelivery, IconTruckLoading, IconAlertOctagon, IconScan, IconDirections, IconList, IconRobot, IconTable, IconCubeSend, IconBuildingWarehouse, IconPlus, IconBox } from '@tabler/icons-react';

// constant
const icons = { IconDashboard, IconDirections, IconTruckDelivery, IconTruckLoading, IconAlertOctagon, IconZoomScan, IconScan, IconList, IconRobot, IconTable, IconCubeSend, IconBuildingWarehouse, IconPlus, IconBox };

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const dashboard = {
    id: 'dashboard',
    title: 'Dashboard',
    type: 'group',
    children: [
        {
            id: 'lecturas',
            title: 'Lecturas',
            type: 'item',
            url: '/dashboard/lecturas',
            icon: icons.IconBox,
            breadcrumbs: false
        },
        {
            id: 'inventario',
            title: 'Inventario',
            type: 'item',
            url: '/dashboard/inventario',
            icon: icons.IconScan,
            breadcrumbs: false
        },
        {
            id: 'expediciones',
            title: 'Expediciones',
            type: 'item',
            url: '/dashboard/expediciones',
            icon: icons.IconTruckLoading,
            breadcrumbs: false
        },
        {
            id: 'incidencias',
            title: 'Incidencias',
            type: 'item',
            url: '/dashboard/incidencias',
            icon: icons.IconAlertOctagon,
            breadcrumbs: false
        },

    ]
};

export default dashboard;
